package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val AccordionContainerStyle = CssStyle {
    base {
        Modifier.padding(leftRight = 20.px)
    }
    Breakpoint.MD {
        Modifier.padding(leftRight = 40.px)
    }
    Breakpoint.LG {
        Modifier.padding(leftRight = 50.px)
    }
}

val AccordionTitleStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(22.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(25.px)
    }
}

val AccordionActionButtonBoxStyle = CssStyle {
    base {
        Modifier.size(26.px)
    }
    Breakpoint.MD {
        Modifier.size(28.px)
    }
    Breakpoint.LG {
        Modifier.size(40.px)
    }
}

val AccordionArrowIconStyle = CssStyle {
    base {
        Modifier.fontSize(16.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(20.px)
    }
}

val AccordionPlusIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(30.px)
    }

}

val AccordionPlusIconStyles = CssStyle {
    base {
        Modifier.size(24.px)
    }
    Breakpoint.MD {
        Modifier.size(36.px)
    }

}